import React, { FC } from 'react'

export const CardDescription: FC = ({ children }): JSX.Element => (
	<div className='card-container__description'>{children}</div>
)
